(() => {
  class NewQuickSearch extends HTMLElement {
    constructor() {
      super();
      this.cache = {};
      this.isOpen = false;
      this.toggleButton = this.querySelector("a[data-search]");
      this.input = this.querySelector("input#search");
      this.form = this.querySelector("form");
      this.inner = this.querySelector("[data-search-inner]");
      this.resultsWrapper = this.querySelector("[data-results]");
      this.clearBtn = this.querySelector("[data-clear]");

      this.init();
    }

    init() {
      document.addEventListener("click", (event) => {
        if (!this.isOpen) return;
        if (event.target.closest("new-quick-search") === this) return;
        this.close();
      });
      window.visualViewport.addEventListener("resize", this.setInnerMaxHeight.bind(this));
      window.addEventListener("scroll", this.setInnerMaxHeight.bind(this), { passive: true });
      this.input.addEventListener("input", this.handleInput.bind(this));
      this.clearBtn.addEventListener("click", this.clear.bind(this));
    }

    close() {
      this.isOpen = false;
      this.classList.add("new-quick-search--empty");
    }

    async handleInput() {
      const html = await this.getHtml();
      this.resultsWrapper.innerHTML = html;
      this.classList.toggle("new-quick-search--empty", !html);
      this.isOpen = !!html;
      if (html) this.setInnerMaxHeight();
    }

    async getHtml() {
      const searchTerm = this.input.value.trim();
      if (searchTerm.length === 0) return "";
      if (this.cache[searchTerm]) return this.cache[searchTerm];

      const url = new URL(`${window.location.origin}${window.theme.routes.predictive_search_url}`);
      url.searchParams.append("q", searchTerm);
      url.searchParams.append("section_id", "predictive-search");

      const response = await fetch(url);
      const htmlString = await response.text();
      const resultsDOM = new DOMParser().parseFromString(htmlString, "text/html");

      const result = resultsDOM.querySelector("#shopify-section-predictive-search").innerHTML;
      this.cache[searchTerm] = result;

      return result;
    }

    setInnerMaxHeight() {
      if (!this.isOpen) return;
      const top = this.inner.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      const gap = window.innerWidth < 960 ? 0 : 20;
      this.inner.style.maxHeight = `${windowHeight - top - gap}px`;
    }

    clear(event) {
      event.preventDefault();
      this.input.value = "";
      this.handleInput();
    }
  }

  if (!customElements.get("new-quick-search")) {
    customElements.define("new-quick-search", NewQuickSearch);
  }
})();
